import { useNavigate } from "react-router-dom";
import { useState } from "react";


export default function Login(props) {

  const [username, setUsername] = useState("Username1");
  const [password, setPassword] = useState("Password1");

  const navigate = useNavigate();

  const handleUsernameChange = (e) => {
    setUsername(e.target.value); // Update the password state
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value); // Update the password state
  };

  const navigateToHome = () => {
    // Navigate to /home and pass username and password as state
    props.setUsername(username);
    navigate("/home", {
      state: { username, password },
    });
  };

  return (
      <div className="">
<div className="flex flex-col py-10 items-center min-h-screen space-y-4">

        <h1 className="text-center text-4xl font-bold text-[#d7dde4]">Cart Sheriff</h1>

        <div className="card card-compact bg-[#d7dde4] w-100 shadow-xl mt-5 py-8">
          <figure>
            <img
              src="/images/CartSheriffLogo.png"
              alt="Cart Sheriff Mascot"
            />
          </figure>

          <div className="card-body mx-auto">
            <label className="input input-bordered flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                className="h-4 w-4 opacity-70"
              >
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" />
              </svg>
              <input type="text" className="grow" placeholder="Username" value={username} onChange={handleUsernameChange} />
            </label>

            <label className="input input-bordered flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                className="h-4 w-4 opacity-70"
              >
                <path
                  fillRule="evenodd"
                  d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                  clipRule="evenodd"
                />
              </svg>
              <input type="password" className="grow" placeholder="Password" value={password} onChange={handlePasswordChange} />
            </label>
          </div>

          <div className="card-actions items-center">
            <button className="btn mx-auto" onClick={navigateToHome}>Login</button>
          </div>
        </div>
      </div>
    </div>
  );
}
